import { render, staticRenderFns } from "./imgJ.vue?vue&type=template&id=d3647aaa"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3647aaa')) {
      api.createRecord('d3647aaa', component.options)
    } else {
      api.reload('d3647aaa', component.options)
    }
    module.hot.accept("./imgJ.vue?vue&type=template&id=d3647aaa", function () {
      api.rerender('d3647aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgJ.vue"
export default component.exports